module.exports = __webpack_public_path__ + "img/incidence.d4568236.svg";